export const SEED_USER = {
  name: 'Alex Kim',
  email: 'alex@example.com',
} as const;
